var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrowIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "rotate(90 15 15)",
    fill: "#F5F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0337 8.68738C14.9735 8.71179 14.9171 8.7484 14.8682 8.79722C14.8682 8.79722 14.8682 8.79722 14.8682 8.79722L13.353 10.3124L7.79718 15.8683C7.60192 16.0635 7.60192 16.3801 7.79718 16.5754L9.31241 18.0906C9.50767 18.2859 9.82425 18.2859 10.0195 18.0906L15.2218 12.8883L20.4241 18.0906C20.6193 18.2859 20.9359 18.2859 21.1312 18.0906L22.6464 16.5754C22.8417 16.3801 22.8417 16.0635 22.6464 15.8683L17.0906 10.3124L15.5754 8.79722C15.5067 8.72856 15.423 8.68404 15.3349 8.66366C15.2351 8.64058 15.1296 8.64849 15.0337 8.68738Z",
    fill: "#593F16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowIconClose);
export default __webpack_public_path__ + "static/media/select-arrow-icon-close.72293f9f4efc86bc5982307076f78ed9.svg";
export { ForwardRef as ReactComponent };